import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

export type GetUserSubscription = {
	subscriptionUserType: string;
	subscriptionDetails?: {
		id: string;
		name: string;
		licenseQuantity: number;
		availableLicenseQuantity: number;
		refundableCredits: number;
		ownerFirstName: string;
		ownerLastName: string;
		ownerId: string;
		organizationAccessRights: {
			accessExportDelegation: boolean;
			accessInviteExternal: boolean;
		};
	};
};

export const useGetUserSubscription = (
	props: Partial<UseQueryOptions<GetUserSubscription>> = {}
) => {
	return useQuery<GetUserSubscription>({
		queryKey: ['getUserSubscription'],
		queryFn: async () => {
			return makeRequest<GetUserSubscription>({
				service: 'userAccount',
				method: 'getUserSubscription'
			});
		},
		...props
	});
};

export function isEnterpriseSubscription(subscription: GetUserSubscription): boolean {
	return subscription?.subscriptionDetails?.name === 'ledidiEnterprise';
}
